import React, { Component } from 'react'
import propTypes from 'prop-types'

import styles from './styles.scss'

/** Components */
import InputNumber from '@/components/InputNumber'

class BorderRadius extends Component {
  state = {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }

  componentDidMount() {
    const { topLeft, topRight, bottomLeft, bottomRight } = this.props

    this.setState({
      borderTopLeftRadius: topLeft,
      borderTopRightRadius: topRight,
      borderBottomLeftRadius: bottomLeft,
      borderBottomRightRadius: bottomRight
    })
  }

  handleBorderRadius = (border, value) => this.setState(prevState => ({
    ...prevState,
    [border]: `${value}px`
  }), () => this.props.onChange(this.state))

  render() {
    const {
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius
    } = this.state

    return (
      <div className={styles['wrapper-border-radius']}>
        <div>
          <InputNumber
            unit={'px'}
            value={parseInt(borderTopLeftRadius, 10)}
            onChange={({ target }) =>
              this.handleBorderRadius('borderTopLeftRadius', target.value)
            }
          />
        </div>
        <div>
          <InputNumber
            unit={'px'}
            value={parseInt(borderBottomLeftRadius, 10)}
            onChange={({ target }) =>
              this.handleBorderRadius('borderBottomLeftRadius', target.value)
            }
          />
        </div>
        <div>
          <InputNumber
            unit={'px'}
            value={parseInt(borderTopRightRadius, 10)}
            onChange={({ target }) =>
              this.handleBorderRadius('borderTopRightRadius', target.value)
            }
          />
        </div>
        <div>
          <InputNumber
            unit={'px'}
            value={parseInt(borderBottomRightRadius, 10)}
            onChange={({ target }) =>
              this.handleBorderRadius('borderBottomRightRadius', target.value)
            }
          />
        </div>
      </div>
    )
  }
}

BorderRadius.propTypes = {
  topLeft: propTypes.string,
  topRight: propTypes.string,
  bottomLeft: propTypes.string,
  bottomRight: propTypes.string,
  onChange: propTypes.func
}

BorderRadius.defaultProps = {
  topLeft: '0px',
  topRight: '0px',
  bottomLeft: '0px',
  bottomRight: '0px',
  onChange: () => { }
}

export default BorderRadius


// WEBPACK FOOTER //
// ./src/components/editors/BorderRadius/index.js